import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2448525a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "project-namespaces-page" }
const _hoisted_2 = { class: "namespace-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "project-namespaces-page__title" }, "Рабочие области", -1))
const _hoisted_4 = { class: "project-namespaces-page__settings" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "create-namespace-drawer__tooltip" }, "Создать рабочую область", -1))
const _hoisted_6 = {
  key: 0,
  style: {"width":"100%"}
}
const _hoisted_7 = {
  class: "project-namespaces-page__list",
  style: {"margin-right":"0.5rem"}
}
const _hoisted_8 = {
  key: 1,
  class: "project-namespaces-page__empty"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["src"]
const _hoisted_11 = { key: 1 }

import {
  ComputedRef,
  inject,
  onBeforeMount,
  onUnmounted,
  ref,
  computed,
  PropType,
  watch,
  onMounted,
} from 'vue';
import { CurrentUser } from 'tir-pm-user-core';
import { BarsArrowDownIcon, BarsArrowUpIcon, PlusIcon } from 'tir-style-system/icons/outline';
import {
  TirPmButton,
  TirPmButtonVariantEnum,
  TirPmButtonSizeEnum,
  TirPmScrollbar,
  TirPmIconView,
  TirPmTooltipElementPlacementEnum,
  TirPmTooltipElement,
  TirPmSearchInput,
} from 'tir-components';
import { TirPmSystemMessage } from 'tir-pm-system-message';

import { projectInjectKey } from '@/inject-keys';
import { CreateNamespaceDrawer, CreateNamespaceResultModel } from '@/components';

import { AdapterService } from './adapter';
import { NamespaceCard } from './components';
import { NamespaceModel } from './models';
import { CreateNamespaceInfo, DeleteNamespaceInfo, UpdateNamespaceInfo } from './types';
import { AdminModel } from '../project-settings-admin-page/models';
import { debounce } from 'tir-pm-debounce';
import ProjectNamespaceListRequest from '@/components/tasks-kanban/adapter/TaskKanbanAdapterService';
import { Skeleton } from './components/skeleton';


export default /*#__PURE__*/_defineComponent({
  __name: 'project-namespaces-page',
  setup(__props) {

const adapter = new AdapterService();

/**Ссылка на шторку создания неймспейса */
const $namespaceDrawer = ref<InstanceType<typeof CreateNamespaceDrawer>>();
/**Проект */
const project = inject(projectInjectKey);
/**Админ проекта */
const isAdminProject = inject('isAdminProject') as ComputedRef<boolean>;
/**Загрузка */
const isLoading = ref(false);
/**Состояние сортировки по названию */
const stateSortName = ref(true);
/**Состояние сортировки по кол-ву задач */
const stateSortCountTasks = ref(false);
/**Выбрана сортировка по названию */
const chooseSortName = ref(true);
/**Выбрана сортировка по кол-ву задач */
const chooseSortCountTasks = ref(false);
/**Поиск */
const search = ref();

/**Список неймспейсов */
const namespaces = ref(new Array<NamespaceModel>());

/**Админ проекта */
const isProjectAdmin = computed(() => {
  const x = CurrentUser;
  const rez = project.value.Admins.find((el) => el.Id == x.Id);
  return rez ? true : false;
});
/**Овнер */
const isOwner = computed(() => {
  const x = CurrentUser;
  const rez = x?.Roles.includes(2);
  return rez ? true : false;
});

/**Получить список неймспейсов */
const getNamespaces = async (_search?: string) => {
  isLoading.value = true;
  const resp = await adapter.getNamespaces(
    new ProjectNamespaceListRequest({
      ProjectId: Number(project.value.Id),
      Search: _search,
    }),
  );
  isLoading.value = false;
  if (!resp.IsSuccess) return;

  namespaces.value = resp.Value;
};
/**Поиск НС */
const searchNamespace = debounce(() => getNamespaces(search.value), 300);
/**При удалении неймспейса */
const onDeleteNamespace = (data: DeleteNamespaceInfo) => {
  namespaces.value = namespaces.value.filter((namespace) => namespace.Id !== data.NamespaceId);
};
/**При создании неймспейса */
const onCreateNamespace = async (data: NamespaceModel) => {
  if (!data.ProjectId || data.ProjectId === project.value.Id) {
    namespaces.value.push(data);
  }
};
/**При обновлении неймспейса */
const onUpdateNamespace = async (data: Partial<NamespaceModel>) => {
  // Неймспейс из списка
  const existNamespace = namespaces.value.find((namespace) => namespace.Id === data.Id);
  if (existNamespace) Object.assign(existNamespace, data);
};
/**Подписаться/отписаться на/от события */
const toggleEvents = (isSubscribe: boolean) => {
  const eventFnName = isSubscribe ? 'on' : 'removeListener';

  adapter.CreateNamespaceEvent[eventFnName](onCreateNamespace);
  adapter.DeleteNamespaceEvent[eventFnName](onDeleteNamespace);
  adapter.UpdateNamespaceEvent[eventFnName](onUpdateNamespace);
};

onBeforeMount(async () => {
  await getNamespaces();
  sortByNameNamespaces();

  toggleEvents(true);
});

onUnmounted(() => {
  toggleEvents(false);
});

/**Сортировать НС по названию */
const sortByNameNamespaces = () => {
  if (stateSortName.value) {
    namespaces.value.sort((a, b) => a.Name.localeCompare(b.Name));
  } else {
    namespaces.value.sort((a, b) => b.Name.localeCompare(a.Name));
  }
  stateSortName.value = !stateSortName.value;
  stateSortCountTasks.value = true;
  chooseSortName.value = true;
  chooseSortCountTasks.value = false;
};

/**Сортировать НС по кол-ву задач */
const sortByCountTasksNamespaces = () => {
  if (stateSortCountTasks.value) {
    namespaces.value.sort((a, b) => a.TasksCount - b.TasksCount);
  } else {
    namespaces.value.sort((a, b) => b.TasksCount - a.TasksCount);
  }
  stateSortCountTasks.value = !stateSortCountTasks.value;
  stateSortName.value = true;
  chooseSortName.value = false;
  chooseSortCountTasks.value = true;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(TirPmSearchInput), {
          isSmall: "",
          modelValue: search.value,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
            _unref(searchNamespace)
          ],
          isWithPopup: false,
          placeholder: "",
          label: "Поиск по названию"
        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
        (isProjectAdmin.value || isOwner.value)
          ? (_openBlock(), _createBlock(_unref(CreateNamespaceDrawer), {
              key: 0,
              "project-id": _unref(project).Id
            }, {
              default: _withCtx(({ open }) => [
                _createVNode(_unref(TirPmButton), {
                  class: "tasks-kanban__header__add",
                  variant: _unref(TirPmButtonVariantEnum).SecondaryState,
                  size: _unref(TirPmButtonSizeEnum).Small,
                  onClick: open
                }, {
                  leftSlot: _withCtx(() => [
                    _createVNode(_unref(PlusIcon))
                  ]),
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 2
                }, 1032, ["variant", "size", "onClick"])
              ]),
              _: 1
            }, 8, ["project-id"]))
          : _createCommentVNode("", true),
        _createVNode(_unref(TirPmButton), {
          variant: _unref(TirPmButtonVariantEnum).LinkState,
          size: _unref(TirPmButtonSizeEnum).Small,
          isPressed: chooseSortName.value,
          onClick: sortByNameNamespaces
        }, {
          rightSlot: _withCtx(() => [
            (stateSortName.value)
              ? (_openBlock(), _createBlock(_unref(BarsArrowUpIcon), { key: 0 }))
              : (_openBlock(), _createBlock(_unref(BarsArrowDownIcon), { key: 1 }))
          ]),
          default: _withCtx(() => [
            _createTextVNode(" По названию ")
          ]),
          _: 1
        }, 8, ["variant", "size", "isPressed"]),
        _createVNode(_unref(TirPmButton), {
          variant: _unref(TirPmButtonVariantEnum).LinkState,
          size: _unref(TirPmButtonSizeEnum).Small,
          isPressed: chooseSortCountTasks.value,
          onClick: sortByCountTasksNamespaces
        }, {
          rightSlot: _withCtx(() => [
            (stateSortCountTasks.value)
              ? (_openBlock(), _createBlock(_unref(BarsArrowUpIcon), { key: 0 }))
              : (_openBlock(), _createBlock(_unref(BarsArrowDownIcon), { key: 1 }))
          ]),
          default: _withCtx(() => [
            _createTextVNode(" По количеству задач ")
          ]),
          _: 1
        }, 8, ["variant", "size", "isPressed"])
      ])
    ]),
    (isLoading.value)
      ? (_openBlock(), _createBlock(_unref(Skeleton), {
          key: 0,
          class: "skeleton"
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (namespaces.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_unref(TirPmScrollbar), {
                  style: _normalizeStyle({ maxHeight: 'calc(100vh - 15rem)' }),
                  "show-on-hover": true
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(namespaces.value, (item) => {
                        return (_openBlock(), _createBlock(_unref(NamespaceCard), {
                          key: item.Id,
                          "namespace-item": item
                        }, null, 8, ["namespace-item"]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }, 8, ["style"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_unref(TirPmSystemMessage), { style: {"margin":"auto"} }, {
                  topDescImage: _withCtx(() => [
                    (_unref(project).ImageUrl)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createElementVNode("img", {
                            src: _unref(project).ImageUrl,
                            class: "project-namespaces-page__empty-project-logo"
                          }, null, 8, _hoisted_10)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createVNode(_unref(TirPmIconView), {
                            size: 64,
                            isRounded: "",
                            isBordered: false,
                            imageLoadUrl: _unref(project).ImageUrl,
                            colorCode: _unref(project).PreviewColor
                          }, {
                            mainSlot: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(project)?.Name[0].toUpperCase()), 1)
                            ]),
                            _: 1
                          }, 8, ["imageLoadUrl", "colorCode"])
                        ]))
                  ]),
                  mainTitleSlot: _withCtx(() => [
                    _createTextVNode("В проекте пусто")
                  ]),
                  actionsSlot: _withCtx(() => [
                    (isOwner.value || _unref(isAdminProject))
                      ? (_openBlock(), _createBlock(_unref(TirPmButton), {
                          key: 0,
                          variant: _unref(TirPmButtonVariantEnum).PrimaryState,
                          size: _unref(TirPmButtonSizeEnum).Regular,
                          onClick: $namespaceDrawer.value?.open
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Создать рабочую область ")
                          ]),
                          _: 1
                        }, 8, ["variant", "size", "onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]))
        ], 64)),
    _createVNode(_unref(CreateNamespaceDrawer), {
      ref_key: "$namespaceDrawer",
      ref: $namespaceDrawer,
      "project-id": _unref(project).Id
    }, null, 8, ["project-id"])
  ]))
}
}

})